module.exports = __webpack_public_path__ + "logo.png?976bbcea1544157299613de2b2eb4d4b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 16
// module chunks = 0